import * as ActionTypes from './ActionTypes';
import { auth, firestore, fireauth, firebasestore, storage } from '../firebase/firebase';

// Action to add a new adventure
export const addAdventure = (adventure) => ({
    type: ActionTypes.ADD_ADVENTURE,
    payload: adventure
});

// Action to post a new adventure
export const postAdventure = (name, description, createdAt, yearSelection, image) => (dispatch) => {

    if (!auth.currentUser) {
        console.log('No user logged in!');
        alert('No user logged in!');
        return;
    }

    const yearSelectionField = {
        [yearSelection]: true
    };

    const storageRef = storage.ref();
    const imageRef = storageRef.child(`adventures/${Date.now()}_${image.name}`);

    return imageRef.put(image)
        .then(() => imageRef.getDownloadURL())
        .then((imageUrl) => {
            // Create the document ID based on the name field
            const documentID = name.replace(/\s+/g, '_').toLowerCase(); // Declare documentID here

            // Set the document with a specific ID
            return firestore.collection('adventures').doc(documentID).set({
                author: {
                    '_id': auth.currentUser.uid,
                    'firstname': auth.currentUser.displayName ? auth.currentUser.displayName : auth.currentUser.email
                },
                name: name,
                description: description,
                image: imageUrl,  // Store the image URL with the field name 'image'
                createdAt: firebasestore.Timestamp.fromDate(new Date(createdAt)),
                ...yearSelectionField,
                updatedAt: firebasestore.FieldValue.serverTimestamp()
            });
        })
        .then(() => {
            return firestore.collection('adventures').doc(name.replace(/\s+/g, '_').toLowerCase()).get()
                .then(doc => {
                    if (doc.exists) {
                        const data = doc.data();
                        const _id = doc.id;
                        let adventure = { _id, ...data };
                        dispatch(addAdventure(adventure));
                        alert('Your adventure has been posted!');
                    } else {
                        console.log("No such document!");
                        alert("No such document!");
                    }
                });
        })
        .catch(error => {
            console.log('Post adventure ', error.message);
            alert('Your adventure could not be posted\nError: ' + error.message);
        });
};

export const addMonth = (month) => ({
    type: ActionTypes.ADD_MONTH,
    payload: month
});

export const postMonth = (payOne, payTwo, emergencyFund, investmentFund, mortgage, water, housingGas, electricity, cable, trash, autoGas, autoMaintenance, groceries, restaurants, phone, clothing, householdItems, funMoney, subscriptions, partnerCare, childCare, gym, medicine, doctorVisits, healthInsurance, autoInsurance, homeInsurance, debt, giving) => (dispatch) => {

    if (!auth.currentUser) {
        console.log('No user logged in!');
        alert('No user logged in!');
        return;
    }

    return firestore.collection('months').add({
        author: {
            '_id': auth.currentUser.uid,
            'firstname': auth.currentUser.displayName ? auth.currentUser.displayName : auth.currentUser.email
        },
        payOne: payOne,
        payTwo: payTwo,
        emergencyFund: emergencyFund,
        investmentFund: investmentFund,
        mortgage: mortgage,
        water: water,
        housingGas: housingGas,
        electricity: electricity,
        cable: cable,
        trash: trash,
        autoGas: autoGas,
        autoMaintenance: autoMaintenance,
        groceries: groceries,
        restaurants: restaurants,
        phone: phone,
        clothing: clothing,
        householdItems: householdItems,
        funMoney: funMoney,
        subscriptions: subscriptions,
        partnerCare: partnerCare,
        childCare: childCare,
        gym: gym,
        medicine: medicine,
        doctorVisits: doctorVisits,
        healthInsurance: healthInsurance,
        autoInsurance: autoInsurance,
        homeInsurance: homeInsurance,
        debt: debt,
        giving: giving,
        createdAt: firebasestore.FieldValue.serverTimestamp(),
        updatedAt: firebasestore.FieldValue.serverTimestamp()
    })
        .then(docRef => {
            firestore.collection('months').doc(docRef.id).get()
                .then(doc => {
                    if (doc.exists) {
                        const data = doc.data();
                        const _id = doc.id;
                        let month = { _id, ...data };
                        dispatch(addMonth(month))
                        alert('Your monthly budget data has been posted!');
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                        alert("No such document!");
                    }
                });
        })
        .catch(error => {
            console.log('Post month ', error.message);
            alert('Your month could not be posted\nError: ' + error.message);
        })
}

export const addAuto = (auto) => ({
    type: ActionTypes.ADD_AUTO,
    payload: auto
});

export const postAuto = (km, fifteen, thirty, fourtyfive, seventyfive, ninety, passcode) => (dispatch) => {

    if (!auth.currentUser) {
        console.log('No user logged in!');
        alert('No user logged in!');
        return;
    }

    return firestore.collection('autos').add({
        author: {
            '_id': auth.currentUser.uid,
            'firstname': auth.currentUser.displayName ? auth.currentUser.displayName : auth.currentUser.email
        },
        km: km,
        fifteen: fifteen,
        thirty: thirty,
        fourtyfive: fourtyfive,
        seventyfive: seventyfive,
        ninety: ninety,
        passcode: passcode,
        createdAt: firebasestore.FieldValue.serverTimestamp(),
        updatedAt: firebasestore.FieldValue.serverTimestamp()
    })
        .then(docRef => {
            firestore.collection('autos').doc(docRef.id).get()
                .then(doc => {
                    if (doc.exists) {
                        const data = doc.data();
                        const _id = doc.id;
                        let auto = { _id, ...data };
                        dispatch(addAuto(auto))
                        alert('Your maintenance completion data has been posted and your next km check has been updated!');
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                        alert("No such document!");
                    }
                });
        })
        .catch(error => {
            console.log('Post auto ', error.message);
            alert('Your update could not be posted\nError: ' + error.message);
        })
}

export const addComment = (comment) => ({
    type: ActionTypes.ADD_COMMENT,
    payload: comment
});

export const postComment = (dishId, rating, comment) => (dispatch) => {

    if (!auth.currentUser) {
        console.log('No user logged in!');
        alert('No user logged in!');
        return;
    }

    return firestore.collection('comments').add({
        author: {
            '_id': auth.currentUser.uid,
            'firstname': auth.currentUser.displayName ? auth.currentUser.displayName : auth.currentUser.email
        },
        dish: dishId,
        rating: rating,
        comment: comment,
        createdAt: firebasestore.FieldValue.serverTimestamp(),
        updatedAt: firebasestore.FieldValue.serverTimestamp()
    })
        .then(docRef => {
            firestore.collection('comments').doc(docRef.id).get()
                .then(doc => {
                    if (doc.exists) {
                        const data = doc.data();
                        const _id = doc.id;
                        let comment = { _id, ...data };
                        dispatch(addComment(comment))
                        alert('Your comment has been posted!');
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                        alert("No such document!");
                    }
                });
        })
        .catch(error => {
            console.log('Post comment ', error.message);
            alert('Your comment could not be posted\nError: ' + error.message);
        })
}

export const fetchDishes = () => (dispatch) => {
    dispatch(dishesLoading(true));

    return firestore.collection('dishes').orderBy("createdAt", "desc").get()
        .then(snapshot => {
            let dishes = [];
            snapshot.forEach(doc => {
                const data = doc.data()
                const _id = doc.id
                dishes.push({ _id, ...data });
            });
            return dishes;
        })
        .then(dishes => dispatch(addDishes(dishes)))
        .catch(error => dispatch(dishesFailed(error.message)));
}

export const dishesLoading = () => ({
    type: ActionTypes.DISHES_LOADING
});

export const dishesFailed = (errmess) => ({
    type: ActionTypes.DISHES_FAILED,
    payload: errmess
});

export const addDishes = (dishes) => ({
    type: ActionTypes.ADD_DISHES,
    payload: dishes
});

export const fetchMonths = () => (dispatch) => {
    return firestore.collection('months').orderBy("createdAt", "desc").get()
        .then(snapshot => {
            let months = [];
            snapshot.forEach(doc => {
                const data = doc.data()
                const _id = doc.id
                months.push({ _id, ...data });
            });
            return months;
        })
        .then(months => dispatch(addMonths(months)))
        .catch(error => dispatch(monthsFailed(error.message)));
}

export const monthsFailed = (errmess) => ({
    type: ActionTypes.MONTHS_FAILED,
    payload: errmess
});

export const addMonths = (months) => ({
    type: ActionTypes.ADD_MONTHS,
    payload: months
});

export const fetchAutos = () => (dispatch) => {
    return firestore.collection('autos').orderBy("createdAt", "desc").get()
        .then(snapshot => {
            let autos = [];
            snapshot.forEach(doc => {
                const data = doc.data()
                const _id = doc.id
                autos.push({ _id, ...data });
            });
            return autos;
        })
        .then(autos => dispatch(addAutos(autos)))
        .catch(error => dispatch(autosFailed(error.message)));
}

export const autosFailed = (errmess) => ({
    type: ActionTypes.AUTOS_FAILED,
    payload: errmess
});

export const addAutos = (autos) => ({
    type: ActionTypes.ADD_AUTOS,
    payload: autos
});

export const fetchComments = () => (dispatch) => {
    return firestore.collection('comments').orderBy("createdAt", "desc").get()
        .then(snapshot => {
            let comments = [];
            snapshot.forEach(doc => {
                const data = doc.data()
                const _id = doc.id
                comments.push({ _id, ...data });
            });
            return comments;
        })
        .then(comments => dispatch(addComments(comments)))
        .catch(error => dispatch(commentsFailed(error.message)));
}

export const commentsFailed = (errmess) => ({
    type: ActionTypes.COMMENTS_FAILED,
    payload: errmess
});

export const addComments = (comments) => ({
    type: ActionTypes.ADD_COMMENTS,
    payload: comments
});

export const fetchFinances = () => (dispatch) => {
    dispatch(financesLoading(true));

    return firestore.collection('finances').get()
        .then(snapshot => {
            let finances = [];
            snapshot.forEach(doc => {
                const data = doc.data()
                const _id = doc.id
                finances.push({ _id, ...data });
            });
            return finances;
        })
        .then(finances => dispatch(addFinances(finances)))
        .catch(error => dispatch(financesFailed(error.message)));
}

export const financesLoading = () => ({
    type: ActionTypes.FINANCES_LOADING
});

export const financesFailed = (errmess) => ({
    type: ActionTypes.FINANCES_FAILED,
    payload: errmess
});

export const addFinances = (finances) => ({
    type: ActionTypes.ADD_FINANCES,
    payload: finances
});

export const fetchAdventures = () => (dispatch) => {
    dispatch(adventuresLoading(true));

    return firestore.collection('adventures').orderBy("createdAt", "asc").get()
        .then(snapshot => {
            let adventures = [];
            snapshot.forEach(doc => {
                const data = doc.data()
                const _id = doc.id
                adventures.push({ _id, ...data });
            });
            return adventures;
        })
        .then(adventures => dispatch(addAdventures(adventures)))
        .catch(error => dispatch(adventuresFailed(error.message)));
}

export const adventuresLoading = () => ({
    type: ActionTypes.ADVENTURES_LOADING
});

export const adventuresFailed = (errmess) => ({
    type: ActionTypes.ADVENTURES_FAILED,
    payload: errmess
});

export const addAdventures = (adventures) => ({
    type: ActionTypes.ADD_ADVENTURES,
    payload: adventures
});

export const fetchCards = () => (dispatch) => {
    dispatch(cardsLoading(true));

    return firestore.collection('cards').get()
        .then(snapshot => {
            let cards = [];
            snapshot.forEach(doc => {
                const data = doc.data()
                const _id = doc.id
                cards.push({ _id, ...data });
            });
            return cards;
        })
        .then(cards => dispatch(addCards(cards)))
        .catch(error => dispatch(cardsFailed(error.message)));
}

export const cardsLoading = () => ({
    type: ActionTypes.CARDS_LOADING
});

export const cardsFailed = (errmess) => ({
    type: ActionTypes.CARDS_FAILED,
    payload: errmess
});

export const addCards = (cards) => ({
    type: ActionTypes.ADD_CARDS,
    payload: cards
});

export const postFeedback = (feedback) => (dispatch) => {

    return firestore.collection('feedback').add(feedback)
        .then(response => { console.log('Feedback', response); alert('Thank you for your feedback!'); })
        .catch(error => { console.log('Feedback', error.message); alert('Your feedback could not be posted\nError: ' + error.message); });
};

export const requestLogin = () => {
    return {
        type: ActionTypes.LOGIN_REQUEST
    }
}

export const receiveLogin = (user) => {
    return {
        type: ActionTypes.LOGIN_SUCCESS,
        user
    }
}

export const loginError = (message) => {
    return {
        type: ActionTypes.LOGIN_FAILURE,
        message
    }
}

export const loginUser = (creds, rememberMe) => (dispatch) => {
    dispatch(requestLogin());

    return auth.signInWithEmailAndPassword(creds.username, creds.password)
        .then(() => {
            const user = auth.currentUser;
            
            // Store user data in localStorage or sessionStorage based on "Remember Me"
            if (rememberMe) {
                localStorage.setItem('user', JSON.stringify(user));
            } else {
                sessionStorage.setItem('user', JSON.stringify(user));
            }
            
            dispatch(receiveLogin(user));
            alert('Welcome ' + creds.username + ' :)');
        })
        .catch(error => {
            dispatch(loginError(error.message));
            alert('Your credentials are invalid, please consult with Aaron.');
        });
};

export const requestLogout = () => {
    return {
        type: ActionTypes.LOGOUT_REQUEST
    }
}

export const receiveLogout = () => {
    return {
        type: ActionTypes.LOGOUT_SUCCESS
    }
}

export const logoutUser = () => (dispatch) => {
    dispatch(requestLogout());

    return auth.signOut()
        .then(() => {
            localStorage.removeItem('user');
            dispatch(receiveLogout());
            alert('You have successfully logged out!');
        })
        .catch((error) => {
            console.error('Logout error: ', error.message);
        });
};

export const googleLogin = () => (dispatch) => {
    const provider = new fireauth.GoogleAuthProvider();

    auth.signInWithPopup(provider)
        .then((result) => {
            var user = result.user;
            localStorage.setItem('user', JSON.stringify(user));
            // Dispatch the success action
            // dispatch(fetchFavorites());  
            dispatch(receiveLogin(user));
            alert('Welcome Admin!');
        })
        .catch((error) => {
            dispatch(loginError(error.message));
        });
}


// WEBPACK FOOTER //
// ./src/redux/ActionCreators.js